import Vue from "vue";
require("es6-promise").polyfill();
import store from "./store";
import App from "./App.vue";
import router from "./router";
import "./styles";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faChevronCircleUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import moment from "moment";

Vue.config.productionTip = false;
Vue.prototype.moment = moment;

library.add(faChevronCircleUp);
Vue.component("font-awesome-icon", FontAwesomeIcon);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
